module.exports = __webpack_public_path__ + "img/logo-client-icon.a54101ae.svg";